import { useEffect } from 'react';

type MountFn = (() => void) | (() => Promise<void>);

/**
 * hook for component mounting.
 *
 * @param mountFn - Required mount function
 * @param unmountFn - Optional unmount function if we use both mount and unmount effects
 */
export const useMount = (mountFn: MountFn, unmountFn?: MountFn) => {
  useEffect(() => {
    mountFn();

    return () => {
      if (unmountFn) {
        unmountFn();
      }
    };
  }, []);
};

/**
 * hook for component unmounting, use when there is no mount effect.
 *
 * @param unmountFn - Required unmount function
 */
export const useUnmount = (unmountFn: MountFn) => {
  useEffect(() => {
    return () => {
      unmountFn();
    };
  }, []);
};
